module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/391.3144eb72.png";